import type { SVGProps } from "react";

export default function SolarCalendarSearchLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" d="M22 14v-2c0-3.771 0-5.657-1.172-6.828S17.771 4 14 4h-4C6.229 4 4.343 4 3.172 5.172S2 8.229 2 12v2c0 3.771 0 5.657 1.172 6.828S6.229 22 10 22h4" />
        <path strokeLinecap="round" d="M7 4V2.5M17 4V2.5" />
        <circle cx={18} cy={18} r={3} />
        <path strokeLinecap="round" d="m20.5 20.5 1.5 1.5M2.5 9h19" />
      </g>
    </svg>
  );
}
